<script setup lang="ts">
import StarIcon from 'assets/icons/star.svg';

const { t } = useI18n();

const route = useRoute();

const isCart = computed(() => {
  return route.name === 'cart';
});

const dataStore = useDataStore();
const DB = useDbStore();

const logout = async () => {
  return await DB.logout()
    .then((e) => {
      reloadNuxtApp();
      return e;
    });
};

// TODO: add call backs against href
const links = [
  { href: '/account/dashboard', label: 'Personal_area' },
  { cb: logout, label: 'Log_out' },
];

const isOpen = ref(false);
const toggle = () => {
  isOpen.value = !isOpen.value;
};

const showLoginAsPopup = ref(false);

const openLoginPopup = async () => {
  showLoginAsPopup.value = true;
};
</script>

<template>
  <div
    v-if="!dataStore.user"
    class="flex gap-4"
  >
    <ButtonLevel
      type="2"
      :title="t('Sign_up')"
      href="/sign-up"
    />
    <ButtonLevel
      v-if="isCart"
      type="3"
      :title="t('Log_in')"
      @click="openLoginPopup"
    />
    <ButtonLevel
      v-else
      type="3"
      :title="t('Log_in')"
      href="/login"
      coded="401"
    />
    <LoginPopup
      v-if="showLoginAsPopup"
      show-as="popup"
      @click-close="showLoginAsPopup = false"
    />
  </div>
  <div
    v-else
    class="flex items-center select-none cursor-pointer gap-4"
  >
    <div class="px-4 py-2 h-9 text-sub text-gray-900 bg-gray-300 rounded whitespace-nowrap flex items-center gap-2">
      <StarIcon />
      <div>{{ t('Balance', { balance: dataStore.bonusAmount }) }}</div>
    </div>
    <DropMenu
      class="max-lg:hidden"
      :links="links"
      side="right"
    >
      <template #default>
        <AvatarCircle
          :name="dataStore.user.name"
          :avatar="dataStore.user.avatar"
        />
      </template>
    </DropMenu>
    <div class="lg:hidden">
      <div
        class="flex items-center gap-4"
        @click="toggle"
      >
        <AvatarCircle
          :name="dataStore.user.name"
          :avatar="dataStore.user.avatar"
        />
        <ButtonLevel
          class="max-md:hidden lg:hidden"
          type="4"
          :title="t('Profile_settings').toUpperCase()"
        />
      </div>

      <template v-if="isOpen">
        <div class="pl-2 py-2">
          <ButtonLevel
            type="4"
            :title="t('Personal_area')"
            @click="navigateTo('/account/dashboard')"
          />
        </div>

        <div class="pl-2 py-2">
          <ButtonLevel
            type="4"
            :title="t('Log_out')"
            @click="logout"
          />
        </div>
        <!--        <div class="bg-gray-300 w-full h-[1px]" /> -->
      </template>
    </div>
  </div>
</template>
